



import * as React from "react";
import { ethers } from "ethers";
import abiJSON from "./utils/LovePortal.json";
import configJSON from "./utils/config.json";
import './App.css';

const App = () => {
  const [currAcount, setCurrentAccount] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [amountLoves, setAmountLoves] = React.useState("");

  const checkIfWalletIsConnected = () => {
    const { ethereum } = window;

    if (!ethereum) {
      console.log("Please connect your wallet.");
      return
    } else {
      console.log("Wallet ok.");
    }

    //check to authorize the accees to the wallet
    ethereum.request({ method: 'eth_accounts' })
      .then(accounts => {
        // check for one
        if (accounts.length !== 0) {
          const account = accounts[0];
          console.log("Authorized account: ", account);

          setCurrentAccount(account);
        } else {
          console.log("Not authorized accounts.");
        }
      })
  }

  const connectWallet = () => {
    const { ethereum } = window;
    if (!ethereum) {
      console.log("Please connect your wallet.");
      return
    }

    ethereum.request({ method: 'eth_requestAccounts' })
      .then(accounts => {
        console.log("Connected", accounts[0])
        setCurrentAccount(accounts[0])
      })
      .catch(err => console.log(err));
  }


  const love = async () => {
    try {

      console.log("message: ", message);
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();

      const loveportalContract = new ethers.Contract(configJSON.contractAddress, abiJSON.abi, signer);

      let count = await loveportalContract.getTotalLoves();
      console.log("Total Loves:", count.toNumber());

      const loveTxn = await loveportalContract.sendLove(message, { gasLimit: 300000 });
      console.log("mining ", loveTxn.hash);

      await loveTxn.wait();
      console.log("mined ", loveTxn.hash);

      count = await loveportalContract.getTotalLoves();
      console.log("Total Loves:", count.toNumber());

      await getAllLoves();
    } catch (e) {
      console.log("errror");
    } finally {

    }

  }

  const [allLoves, setAllLoves] = React.useState([]);
  async function getAllLoves() {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const loveportalContract = new ethers.Contract(configJSON.contractAddress, abiJSON.abi, signer);

    let count = await loveportalContract.getTotalLoves();

    console.log(count);
    setAmountLoves(count.toString());
    let loves = await loveportalContract.getAllLoves();

    let lovesCleaned = [];
    loves.forEach(love => {
      console.log(love);
      lovesCleaned.push({
        address: love.sender,
        timestamp: new Date(love.timestamp * 1000),
        message: love.message
      })
    })

    setAllLoves(lovesCleaned);

    loveportalContract.on("NewLove", (from, timestamp, message) => {
      console.log("NewLove", from, timestamp, message)
      setAllLoves(oldArray => [...oldArray, {
        address: from,
        timestamp: new Date(timestamp * 1000),
        message: message
      }])
    })
  }

  React.useEffect(() => {
    const fetchData = async () => {
      await getAllLoves();
    }
    fetchData();
    checkIfWalletIsConnected();
  }, [])

  return (
    <div className="mainContainer">

      <div className="dataContainer">
        <div className="header">
          Hey there!
        </div>

        <div className="bio">
          I am Tom. Just send some crypto love  <span role="img" aria-label="love">🥰</span>
        </div>

        <div className="TextBoxDiv">
          <input className="loveTextBox" onChange={({ target: { value } }) => setMessage(value)} placeholder="Enter message..." value={message} />
        </div>

        <button className="waveButton" onClick={love}>
          Send Love <span role="img" aria-label="heart">❤️</span>
        </button>

        {currAcount ? null : (
          <button className="waveButton" onClick={connectWallet}>
            Connect Wallet
          </button>
        )}

        <div className="bio">
          Crypto Loves: {amountLoves}
        </div>

        {allLoves.map((love, index) => {
          return (
            <div key="{index}" style={{ backgroundColor: "OldLave", marginTop: "16px", padding: "8px" }}>
              {/*<div>Address: {love.address}</div>*/}
              {/*<div>Time: {love.timestamp.toString()}</div>*/}
              <div><span role="img" aria-label="heart">❤️</span> .. {love.message}</div>
            </div>
          )
        })}
      </div>
    </div>
  );
}


export default App;